import { render, staticRenderFns } from "./HsabLoginWrapper.vue?vue&type=template&id=230e6936&scoped=true"
import script from "./HsabLoginWrapper.vue?vue&type=script&lang=ts"
export * from "./HsabLoginWrapper.vue?vue&type=script&lang=ts"
import style0 from "./HsabLoginWrapper.vue?vue&type=style&index=0&id=230e6936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e6936",
  null
  
)

export default component.exports